import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="bg-paper" data-id="element-167" data-mp="3krp5n656qzqv">
      <div className="mx-auto max-w-6xl px-5 py-12 lg:py-24" data-id="element-168" data-mp="3fyvykbm8vfbm">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-169" data-mp="3fxb3mkw0pud8">
          <h2 id="testimonials-title" className="max-w-xl font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-170" data-mp="3ayhz3hypldp7">
            What people who already have it are saying
          </h2>
          <p className="md:text-right" data-id="element-171" data-mp="3229187qdqn56">
            <span className="block font-display text-4xl font-black text-rust-dark" data-id="element-172" data-mp="2x006b5ty5b0f">300+</span>
            <span className="text-ink-soft" data-id="element-173" data-mp="2s2i4s0i9dy2g">people helped, and here are a few of them</span>
          </p>
        </div>
        <ul className="mt-8 grid gap-4 sm:mt-12 sm:gap-6 md:grid-cols-3" data-id="element-174" data-mp="v8589t0m550o">
          {testimonials.map(t => <li key={t.name} data-id="element-175" data-mp="qbeqn195u1d5">
              <figure className="flex h-full flex-col rounded-2xl bg-cream p-5 ring-1 ring-kraft-dark/20 sm:p-7" data-id="element-176" data-mp="q893vso07bkl">
                <div className="flex gap-0.5 text-rust" aria-label="5 out of 5 stars" data-id="element-177" data-mp="h8axnbsvonq6">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-178" data-mp="78a9nck2djfn" data-mpi={i} />)}
                </div>
                <blockquote className="mt-4 flex-1 text-lg leading-relaxed" data-id="element-179" data-mp="c7wofqfjj7qk">“{t.quote}”</blockquote>
                <figcaption className="mt-6 flex items-center gap-3" data-id="element-180" data-mp="zxh86bjiq90w">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-kraft font-display font-black" data-id="element-181" data-mp="14v9alzhshdjc">
                    {t.name.charAt(0)}
                  </span>
                  <span className="font-display font-extrabold" data-id="element-182" data-mp="v5pqkqicbdmw">{t.name}</span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}